import React, {Fragment} from 'react';

import {Card, Stack} from '@mui/material';
import {MainFooter, MainHeader} from 'presentation/components';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {translations} from 'presentation/translations-new';
import {QualityCertificationBanner} from '../../../../components/QualityCertificationBanner';
import {useTelehealthConfirmationBookingContent} from './hooks/useTelehealthConfirmationBookingContent';
import {StyledContainer, StyledFooterBox} from './styles';
import {TelehealthConfirmationBookingContentProps} from './types';

import {ActionButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ActionButtons';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import {ConfirmationCTAButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ConfirmationCTAButtons';
import {SuccessHeader} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/SuccessHeader';
import {PrintTemplateNew} from 'presentation/modules/booking/shared/ui/components/PrintTemplateNew';
import {TelehealthVideoCard} from './components/TelehealthVideoCard';

const {confirmationBooking} = translations['pt-br'].privateFlow.bookingFlow;

export function TelehealthConfirmationBookingContentNew({
	bookedAppointment,
	goToMyAppointments,
}: TelehealthConfirmationBookingContentProps) {
	const {
		isMobile,
		isPrinting,
		isSharing,
		printContent,
		printRef,
		calendarEvent,
		date,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		beneficiaryName,
		planName,
		tutorialLink,
		goToHome,
		shareContent,
	} = useTelehealthConfirmationBookingContent(bookedAppointment);

	return (
		<Fragment>
			<MainHeader
				title={confirmationBooking}
				handleClose={goToHome}
				hideBackBtn
				variant="subRoute"
			/>

			<StyledContainer>
				<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
					<Stack gap={3}>
						<SuccessHeader flowType={FlowEnum.TELEHEALTH} />

						<AppointmentInfoList
							beneficiaryName={beneficiaryName}
							planName={planName}
							providerName={providerName}
							specialtyName={specialtyName}
							date={date}
							hour={hour}
							protocolNumber={protocolNumber}
							flowType={FlowEnum.TELEHEALTH}
						/>

						<ActionButtons
							isMobile={isMobile}
							isPrinting={isPrinting}
							printContent={printContent}
							shareContent={shareContent}
							calendarEvent={calendarEvent}
							isSharing={isSharing}
						/>

						<TelehealthVideoCard tutorialLink={tutorialLink} />
					</Stack>
				</Card>

				<ConfirmationCTAButtons
					goToMyAppointments={goToMyAppointments}
					goToHome={goToHome}
					isMobile={isMobile}
				/>
			</StyledContainer>

			<StyledFooterBox>
				<QualityCertificationBanner />
				<MainFooter />
			</StyledFooterBox>

			<PrintTemplateNew
				bookedAppointment={bookedAppointment}
				flowType={FlowEnum.TELEHEALTH}
				printRef={printRef}
			/>
		</Fragment>
	);
}
